// @ts-check
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useSettingRef } from '@erpagroapp/settings';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

export function useSortedProductionLines() {
  const { getLineasProduccion } = storeToRefs(useTraceabilityStore());
  const palletizingPointsOrderField = useSettingRef('PuntosPaletizado.CampoOrdenacionPuntosPaletizado');

  /**
   * Returns a list of production list with sorted palletizing points according to settings.
   * @returns {import('@erpagroapp/types').LineaProduccion[]}
   * The list of production lines with sorted palletizing points.
   */
  const sortedProductionLines = computed(() => {
    if (!palletizingPointsOrderField.value) {
      return getLineasProduccion.value;
    }

    const orderBy = {
      Id: palletizingPointsOrderField.value === 'Id',
      Codigo: palletizingPointsOrderField.value === 'Codigo',
      Nombre: palletizingPointsOrderField.value === 'Nombre',
    };

    /** @type {import('@erpagroapp/types').LineaProduccion[]} */
    const sortedLineasProduccion = getLineasProduccion.value.map((lineaProduccion) => {
      const sortedPuntosPaletizado = lineaProduccion?.PuntosDePaletizado?.slice().sort((a, b) => {
        if (orderBy.Id) {
          return a.Id - b.Id;
        } if (orderBy.Codigo && a.Codigo && b.Codigo) {
          return a.Codigo.localeCompare(b.Codigo, undefined, { numeric: true, sensitivity: 'base' });
        } if (orderBy.Nombre && a.Nombre && b.Nombre) {
          return a.Nombre.localeCompare(b.Nombre, undefined, { numeric: true, sensitivity: 'base' });
        }
        return 0;
      });

      return { ...lineaProduccion, PuntosDePaletizado: sortedPuntosPaletizado || [] };
    });

    return sortedLineasProduccion;
  });

  return {
    sortedProductionLines,
  };
}
